import _get from 'lodash/get';
import _map from 'lodash/map';

import initialState from './initialState';
import actionType from './actionTypes';

const adjustmentConfigurationReducer = (state = initialState, action) => {
    try {
        switch (action.type) {
            case actionType.GET_ADJUSTMENT_CONFIGURATION_SUCCESS: {
                return {
                    ...state,
                    adjustmentConfigurationGridRowData: _get(action.payload, 'gridRowData', []),
                    sourceColumnsForSelectionBox: _get(action.payload, 'sourceColumns', []),
                    isAdjustmentConfiguration: _get(action.payload, 'isAdjustmentConfiguration', []),
                    sourceRefId: _get(action.payload, 'sourceRefId', 'Select Source'),
                };
            }
            case actionType.GET_ADJUSTMENT_CONFIGURATION_FAILURE: {
                return {
                    ...state,
                    adjustmentConfigurationGridRowData: [],
                    sourceColumnsForSelectionBox: [],
                    isAdjustmentConfiguration: false,
                    sourceRefId: _get(action.payload, 'sourceRefId', 'Select Source'),
                };
            }

            case actionType.GET_WORKFLOW_RULE_NAME_RULE_SUCCESS: {
                return {
                    ...state,
                    workflowRuleNames: action.payload,
                    workflowRuleNamesForSelectionBox: _map(action.payload, (o) => ({
                        ...o,
                        label: o.rule_name,
                        value: o.rule_name,
                    })),
                };
            }
            case actionType.GET_WORKFLOW_CONFIGURATION_SUCCESS:
                return {
                    ...state,
                    workflowConfigurations: action.payload,
                };
            case actionType.SET_RECON_COLUMN_FIELDS:
                return {
                    ...state,
                    reportReconColumnFields: action.payload,
                };
            case actionType.GET_SERVER_FOLDERS:
                return {
                    ...state,
                    serverFolderPaths: action.payload,
                };
            case actionType.GET_ALL_REPORTS_WORKFLOW:
                return {
                    ...state,
                    allReportsWorkflow: _map(action.payload, (o) => ({
                        ...o,
                        label: o.workflow_name,
                        value: o.workflow_name,
                    })),
                };
            case actionType.SET_DB_COLUMNS:
                return {
                    ...state,
                    dbImportColumns: action.payload,
                };
            case actionType.SET_AUTO_MAP:
                return {
                    ...state,
                    isAutoMap: action.payload,
                };
            case actionType.GET_FILE_TEMPLATES:
                return {
                    ...state,
                    allFileTemplates: action.payload,
                };
            case actionType.GET_WORKFLOW_CONFIGURATION_BY_RECON_SUCCESS:
                return {
                    ...state,
                    workflowConfigurationRecon: action.payload,
                };
            case actionType.CLEAR_WORKFLOW_CONFIGURATION_BY_RECON:
                return {
                    ...state,
                    workflowConfigurationRecon: [],
                };
            default:
                return state;
        }
    } catch (e) {
        console.error(e);
    }
};

export default adjustmentConfigurationReducer;
